import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zoom-layout',
  templateUrl: './zoom-layout.component.html',
  styleUrls: ['./zoom-layout.component.css']
})
export class ZoomLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
